export const BASE_URL = "https://backend.manaprint.in/public/api";


// export const BASE_URL = "https://acsdev.in/manaprint_backend/public/api";
export const IMAGE_BASE_URL = "https://acsdev.in/manaprint_backend/public/uploads";

// export const BASE_URL = "http://localhost/printing/public/api";
// export const IMAGE_BASE_URL = "http://localhost/printing/public/uploads";
export const CDN_URL = "https://cdn.acsdev.in/ManaPrint";